export interface PaysafePaymentMethods {
  card: { error?: unknown };
}
